import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue")
  },
  {
    path: "/postUnyo",
    name: "postUnyo",
    component: () =>
      import(/* webpackChunkName: "postUnyo" */ "@/views/postUnyo.vue")
  },
  {
    path: "/policy",
    name: "policy",
    component: () =>
      import(/* webpackChunkName: "policy" */ "@/views/policy.vue")
  },
  {
    path: "/generator",
    name: "generator",
    component: () =>
      import(/* webpackChunkName: "generator" */ "@/views/generator.vue")
  },
  {
    path: "/calibration",
    name: "calibration",
    component: () =>
      import(/* webpackChunkName: "calibration" */ "@/views/calibration.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },
  routes
});

export default router;
